import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseCoordinates',
  standalone: true,
})
export class ParseCoordinatesPipe implements PipeTransform {
  transform(value: string): [string, string] {
    if (!value) {
      return ['0', '0'];
    }
    return value.split(',').reverse() as [string, string];
  }
}
